import { Trans, useLingui } from "@lingui/react";
import { TradeOrgPages } from "src/types/tradeorgPages.ts";
import OrgLinks from "./components/OrgLinks.tsx";
import Title from "./components/Title.tsx";
import { Layout } from "./Layout.tsx";

const Norboat = () => {
  const { i18n } = useLingui();
  const pageName = TradeOrgPages.Norboat;

  const pageTitle = i18n._({
    id: "tradeOrgLayout.page.title",
    message: "Advantages with {tradeOrgName}",
    comment: "Page title with trade organization name",
    values: { tradeOrgName: pageName.toUpperCase() },
  });

  return (
    <Layout
      left={
        <>
          <Title title={pageTitle} />

          <div className="mt-40">
            <div className="mt-40 pb-40 border-b md:border-none">
              <h4 className="t4 mb-0">
                <Trans
                  id="tradeOrgLayout.norboat.section.one.text.title"
                  message="This boat is sold by a member of Norboat"
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </h4>

              <p className="mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.norboat.section.one.text.partOne"
                  message={
                    'Norboat is the Boating Industry Association in Norway and works for a unified Norwegian boating industry and has 354 member companies. Norboat\'s motto is "For your safety". When you buy a product or service from a Norboat member, you know that they are associated with a trade organization that works to create the best possible framework conditions for the boating industry and boating based on safe boat ownership.'
                  }
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </p>

              <p className="mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.norboat.section.two.text.partTwo"
                  message="Norboat is owned by the industry itself, through our three owner associations Norske Båtbyggeriers Landsforening (NBL), Norges Båtbransjeforbund (NBF) and Motorimportørenes Forening (MIF). Norboat works actively to promote boating and boating interest."
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </p>

              <p className="mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.norboat.section.three.text.partThree"
                  message="Norboat also authorizes the boat industry's players in the disciplines Boat broker, Marine engine workshop, Plastic repair workshop, Gas installer and Boat appraiser. Those members who allow themselves to be authorized live up to strict regulations, which should contribute to increased security for consumers and increased safety at sea."
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </p>

              <p className="mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.norboat.section.four.text.partFour"
                  message="Remember to look for the Authorization logo the next time you order services for your boat."
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </p>
            </div>
          </div>
        </>
      }
      right={<OrgLinks pageName={pageName} />}
    />
  );
};

export default Norboat;
